/**
 * GPT分析页面
 */

export default {
  dbl_gpt_title: "Chat BI",
  dbl_gpt_message_empty: "输入问题，启用AI分析",
  dbl_gpt_query: "在查询中",
  dbl_gpt_query_complete: "查询完成",
  dbl_gpt_message_query_thinking: "思考中...",
  dbl_gpt_message_thinking: "⏳ 思考中...",
  dbl_gpt_message_analysis_thinking: "⏳ 数据分析中...",
  dbl_gpt_message_thinking_info: "（如果等待超过 60 秒，请重新开启一次问答会话）",
  dbl_gpt_message_continue: "请输入【继续】或给出人工反馈",
  dbl_gpt_message_complete: "任务标记为完成！",
  dbl_gpt_input_placeholder: "请输入有关游戏的问题",
  dbl_gpt_result_list: "结果列表",
  dbl_gpt_clear: "清空",
  dbl_gpt_send: "发送",
  dbl_gpt_stop: "停止",
  dbl_gpt_gpt_link: "跳转情报系统页面",
  dbl_gpt_copy_image: "复制图片",
  dbl_gpt_copy_table: "复制表格",
  dbl_gpt_home_tip_title: "💡 提示",
  dbl_gpt_prompt_title: "目前仅支持所选游戏(默认为Demo游戏)的经分数据与DataBrain情报数据的GPT自助分析。你可以问任何游戏的数据问题，我们会基于可用的数据源想你给出答案。<br/>舆情数据，以及任意游戏数据查询和交叉分析开发中，敬请期待。",
  dbl_gpt_prompt_content_title:	"您可以这么问:",
  dbl_gpt_prompt_content:	"<b>1. 最近活跃情况怎么样？</b> <br/> <b>2. 最近付费情况怎么样？</b> <br/> <b>3. 按平台分析最近一周的每日活跃情况</b><br/> <b>4. 按国家分析最近一周的每日付费情况</b>",

  dbl_gpt_home_top_title: "输入问题，😎 启用AI分析",
  dbl_gpt_home_top_des: "当前位置已被回答 <span>{count}</span> 次",

  dbl_gpt_home_questions_title: "🤔 示例提示",
  dbl_gpt_home_table_total: "共{total}项",

  dbl_gpt_home_guide_title: "🏗️ 工作原理",
  dbl_gpt_home_guide_first_title: "输入您的问题",
  dbl_gpt_home_guide_first_des: "根据你输入的问题分解关键词",
  dbl_gpt_home_guide_first_input: "输入",
  dbl_gpt_home_guide_first_input_question: "最近的DAU怎么样？",
  dbl_gpt_home_guide_first_AI: "AI",
  dbl_gpt_home_guide_first_AI_answer: "<b><i>2023-05-24年至2023-05-31年每日活跃用户</i>如何？</b>",
  dbl_gpt_home_guide_second_title: "将问题转换为SQL",
  dbl_gpt_home_guide_second_des: "支持复制",
  dbl_gpt_home_guide_third_title: "可视化并输出结果",
  dbl_gpt_home_guide_third_des: "支持查询和下载",
  dbl_gpt_more_analysis: "想看更多分析吗? ",
  dbl_gpt_tool_try: "试试我们的智能分析工具吧!",
  dbl_gpt_search_online: "我需要在网上搜索一下",
  dbl_gpt_information_source: "数据来源",
  dbl_gpt_Keep_asking_questions: "你可以继续问我",
  dbl_gpt_related_page: "数据库相关页面: ",
  dbl_gpt_rate_of_change: "以变化率排序",
  dbl_gpt_home_faq: "🔍 常见问题",
  dbl_gpt_home_faq_content: "### ChatBI的局限性有哪些？\n" +
		"1. ChatBI基于ChatGPT开发，因此也存在一些相关的限制：\n" +
		"\t- 幻觉：尽管DataBrain团队在输出质量和过程透明性方面做了大量工作，但是ChatGPT可能会产生一些误导性的回答\n" +
		"\t- 专业知识不足：目前，DataBrain团队仅向ChatBI注入了数据分析相关的知识，对于游戏领域的其他专业知识，ChatBI可能无法提供全面的支持\n" +
		"\n" +
		"2. ChatBI的数据来源有限：\n" +
		"\t- 来自授权的经分数据（DashBoard）：您只能访问您有权限的经分数据。如果您没有相关权限，ChatBI将使用demo数据或情报数据来回答您的问题\n" +
		"\t- 来自购买的市场数据（Intelligence）：DataBrain购买了AppAnnie、SensorTower等市场数据，可以为您提供详实的榜单数据。但请注意，ChatBI目前暂未支持情报数据，情报榜单和基础指标数据将在未来两周陆续提供\n" +
		"\t- 来自爬虫获取的舆情数据（Opinions）：DataBrain通过爬虫收集了海外社交平台上的玩家反馈，并结合NLP技术，从多个角度为用户呈现舆情内容指标和总结报告，舆情数据将在接下来一个月接入ChatBI\n" +
		"\n" +
		"3. ChatBI的功能有限：目前，ChatBI能够提供基础的SQL编写、可视化展示、数据洞察和简单预测等功能，更多的功能正在开发中。\n" +
		"\n" +
		"### 为什么我的提问没有得到回答？\n" +
		"可能的原因包括：\n" +
		"- 数据权限不足：您可能没有访问相关数据的权限。如果需要申请权限，请联系<span class='dbl-gpt-home-faq-conact'>@v_blljli</span>\n" +
		"- GPT4带宽限制：尽管DataBrain团队的GPT4接口可以承受每分钟数百次的访问，GPT3.5甚至可以承受上千次的调用，但是仍然可能会出现API受限的情况。如果出现相关提示，请刷新页面后重试\n" +
		"- 网络问题：您的网络连接可能存在问题\n" +
		"\n" +
		"### 如果我对ChatBI的回答不满意，我应该如何提高我的提问质量？\n" +
		"我们会利用GPT4对您的问题进行标准化，所以即使您的问题描述不是很清晰，我们也会尽力提供一个答案。如果您对答案不满意，我们建议您尝试以下方法：\n" +
		"- 尽可能清晰地描述您的问题，最好包括指标、维度和时间颗粒度，这将有助于减轻GPT的理解压力\n" +
		"- 如果您对某个答案不满意，可以给它点踩。我们会在1-3个工作日内处理您的反馈，您的协作将有助于ChatBI的持续改进"

};
